export default "/images/1026fbe295932bf002c56dc8fee5b876.avif";